export enum IndexType {
    First,
    Last,
    Custom
}
